// extracted by mini-css-extract-plugin
export default {"table":"style_table__z7kfz","withBorderRadiusBottom":"style_withBorderRadiusBottom__yOF6g","withBorder":"style_withBorder__TKlNZ","pending":"style_pending__qKbtR"};